import {
  AppRootElementBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { DefaultFavoritesSeeder } from '../../components/seeds/DefaultFavoritesSeeder';

/**
 * Mounts `DefaultFavoritesSeeder` at the React app root via
 * `AppRootElementBlueprint`. The blueprint attaches to
 * `app/root → elements`, so the element is rendered on every page,
 * once per app session — which is exactly what we need for a
 * side-effect-only component that wants to run a single `useEffect`
 * during the app's lifetime.
 *
 * Why this is its own module instead of being attached to (e.g.)
 * `catalogModule`:
 *
 *   - Future seeds may target plugins beyond the catalog (e.g. a
 *     default home-tab pin, default search filters, default RBAC
 *     conditions for new users). Keeping a dedicated `seedsModule`
 *     means we have one obvious home for "things this portal hands
 *     every new user out of the box" without each seed having to
 *     pick a parent plugin.
 *
 *   - The seeder uses the `starredEntitiesApi` from the catalog
 *     plugin AND the `storageApi` from core — it's not really "owned"
 *     by either plugin. A dedicated module keeps the dependency graph
 *     explicit.
 */
const defaultFavoritesSeederExtension = AppRootElementBlueprint.make({
  name: 'default-favorites-seeder',
  params: {
    element: <DefaultFavoritesSeeder />,
  },
});

export const seedsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [defaultFavoritesSeederExtension],
});
